/**
   * Parses a raw string value into the appropriate JS type based on the
   * DevExtreme editor type.
   *
   * | inputType          | returned type |
   * |--------------------|---------------|
   * | dxCheckBox         | boolean       |
   * | dxNumberBox        | number        |
   * | dxDateBox          | Date          |
   * | everything else    | string        |
   *
   * Returns `undefined` when `value` is null / undefined / empty string so that
   * DevExtreme uses its own internal default instead of an empty value.
   */
export function parseTypedValue(value: string, inputType: string): boolean | number | Date | string | undefined {
    if (value == null || value === '') return undefined;

    if (value.startsWith('__') && value.endsWith('__')) {
        return parseDynamicValue(value, inputType);
    }

    switch (inputType) {
        case 'dxCheckBox':
            return value.toLowerCase() === 'true';

        case 'dxNumberBox':
            const n = Number(value);
            return isNaN(n) ? undefined : n;

        case 'dxDateBox':
            const d = new Date(value);
            return isNaN(d.getTime()) ? undefined : d;

        default:
            return value;
    }
}

export function toBoolean(value: boolean | string | undefined): boolean | undefined {
    if (value === null || value === undefined) return undefined;

    if (typeof value === 'boolean') return value;
    if (typeof value === 'string') return value.toLowerCase() === 'true';
    return Boolean(value);
}

function parseDynamicValue(value: string, inputType: string): boolean | number | Date | string {
    const dynamicKey = value.substring(2, value.length - 2);

    switch (inputType) {
        case 'dxDateBox': {
            if(dynamicKey === 'NOW') {
                return new Date();
            }
        }
    }

    return '';
}